export const SOCIAL_MEDIA_METADATA = [
  {
    id: '1',
    icon: 'tiktok',
    label: 'TikTok',
    state: [
      { isValid: true, route: '', isVisible: true },
      { isValid: true, route: '/', isVisible: true },
      { isValid: true, route: '/socialinsights', isVisible: true },
      { isValid: true, route: '/influencers/activeFollowers', isVisible: true },
      {
        isValid: true,
        route: '/influencers/activeInfluencers',
        isVisible: true,
      },
      { isValid: true, route: '/resultsView', isVisible: true },
      {
        isValid: true,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/ActiveInfluencersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: true, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '2',
    icon: 'instagram',
    label: 'Instagram',
    state: [
      { isValid: true, route: '', isVisible: true },
      { isValid: true, route: '/', isVisible: true },
      { isValid: true, route: '/socialinsights', isVisible: true },
      { isValid: true, route: '/influencers/activeFollowers', isVisible: true },
      {
        isValid: true,
        route: '/influencers/activeInfluencers',
        isVisible: true,
      },
      { isValid: true, route: '/resultsView', isVisible: true },
      {
        isValid: true,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/ActiveInfluencersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: true, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '3',
    icon: 'fb-simple',
    label: 'Facebook',
    state: [
      { isValid: false, route: '', isVisible: true },
      { isValid: false, route: '/', isVisible: true },
      { isValid: false, route: '/socialinsights', isVisible: true },
      { isValid: true, route: '/influencers/activeFollowers', isVisible: true },
      {
        isValid: true,
        route: '/influencers/activeInfluencers',
        isVisible: true,
      },
      { isValid: false, route: '/resultsView', isVisible: true },
      {
        isValid: true,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/ActiveInfluencersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '4',
    icon: 'twitter',
    label: 'Twitter',
    state: [
      { isValid: false, route: '', isVisible: true },
      { isValid: false, route: '/', isVisible: true },
      { isValid: false, route: '/socialinsights', isVisible: true },
      { isValid: true, route: '/influencers/activeFollowers', isVisible: true },
      {
        isValid: true,
        route: '/influencers/activeInfluencers',
        isVisible: true,
      },
      { isValid: false, route: '/resultsView', isVisible: true },
      {
        isValid: true,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/ActiveInfluencersResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/comparisonhub',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '5',
    icon: 'youtube',
    label: 'Youtube',
    state: [
      { isValid: false, route: '', isVisible: true },
      { isValid: false, route: '/', isVisible: true },
      { isValid: false, route: '/socialinsights', isVisible: true },
      { isValid: true, route: '/influencers/activeFollowers', isVisible: true },
      {
        isValid: false,
        route: '/influencers/activeInfluencers',
        isVisible: false,
      },
      { isValid: false, route: '/resultsView', isVisible: true },
      {
        isValid: true,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: false,
        route: '/ActiveInfluencersResultsView',
        isVisible: false,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },

  {
    id: '6',
    icon: 'news',
    label: 'News',
    state: [
      { isValid: false, route: '', isVisible: true },
      { isValid: false, route: '/', isVisible: true },
      { isValid: false, route: '/socialinsights', isVisible: true },
      {
        isValid: false,
        route: '/influencers/activeFollowers',
        isVisible: true,
      },
      {
        isValid: false,
        route: '/influencers/activeInfluencers',
        isVisible: false,
      },
      { isValid: false, route: '/resultsView', isVisible: true },
      {
        isValid: false,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: false,
        route: '/ActiveInfluencersResultsView',
        isVisible: false,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '7',
    icon: 'reddit',
    label: 'Reddit',
    state: [
      { isValid: false, route: '', isVisible: true },
      { isValid: false, route: '/', isVisible: true },
      { isValid: false, route: '/socialinsights', isVisible: true },
      {
        isValid: false,
        route: '/influencers/activeFollowers',
        isVisible: true,
      },
      {
        isValid: false,
        route: '/influencers/activeInfluencers',
        isVisible: false,
      },
      { isValid: false, route: '/resultsView', isVisible: true },
      {
        isValid: false,
        route: '/ActiveFollowersResultsView',
        isVisible: true,
      },
      {
        isValid: false,
        route: '/ActiveInfluencersResultsView',
        isVisible: false,
      },
      {
        isValid: true,
        route: '/MentionsTimelineResultsView',
        isVisible: true,
      },
      {
        isValid: true,
        route: '/socialMentionsSmartInbox/mentionsTimeline',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/dashboard', isVisible: true },
      { isValid: true, route: '/brandintel/comparisonhub', isVisible: true },
      {
        isValid: true,
        route: '/brandintel/_comparisonhubsmb',
        isVisible: true,
      },
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/haix-genai/summary', isVisible: true },
      { isValid: true, route: '/alerts', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: true },
      { isValid: false, route: '/genai-live', isVisible: true },
    ],
  },
  {
    id: '8',
    icon: 'linkedin',
    label: 'LinkedIn',
    state: [
      { isValid: false, route: '/brandintel/trackcompanies', isVisible: true },
      { isValid: false, route: '/brandintel/dashboard', isVisible: false },
      { isValid: false, route: '/brandintel/comparisonhub', isVisible: false },
      { isValid: true, route: '/profile', isVisible: true },
      { isValid: true, route: '/profile/subscription', isVisible: true },
      { isValid: true, route: '/linkedin/insights/', isVisible: true },
      { isValid: false, route: '/livesearch', isVisible: false },
      { isValid: false, route: '/genai-live', isVisible: false },
      // { isValid: false, route: "/haix-genai/summary", isVisible: true },
    ],
  },

  //   {
  //   id: "9",
  //   icon: "linkedin",
  //   label: "linkedinPublicPage",
  // state: [
  //     // { isValid: true, route: "/portfolio/trackcompanies", isVisible: true },
  //     // { isValid: true, route: "/profile", isVisible: true },
  //       // { isValid: true, route: "/haix-genai/summary", isVisible: true },
  //   ],
  // },

  //   {
  //   id: "9",
  //   icon: "linkedin",
  //   label: "LinkedInPublic",
  //   state: [
  //       { isValid: true, route: "/haix-genai/summary", isVisible: true },
  //   ],
  // },
  // {
  //   id: "9",
  //   icon: "trustpilot",
  //   label: "Trustpilot",
  //   state: [
  //     { isValid: true, route: "", isVisible: true },
  //     { isValid: true, route: "/", isVisible: true },
  //     { isValid: true, route: "/socialinsights", isVisible: true },
  //     { isValid: true, route: "/influencers/activeFollowers", isVisible: true },
  //     {
  //       isValid: true,
  //       route: "/influencers/activeInfluencers",
  //       isVisible: true,
  //     },
  //     { isValid: true, route: "/resultsView", isVisible: true },
  //     {
  //       isValid: true,
  //       route: "/ActiveFollowersResultsView",
  //       isVisible: true,
  //     },
  //     {
  //       isValid: true,
  //       route: "/ActiveInfluencersResultsView",
  //       isVisible: true,
  //     },
  //     {
  //       isValid: true,
  //       route: "/MentionsTimelineResultsView",
  //       isVisible: true,
  //     },
  //     {
  //       isValid: true,
  //       route: "/socialMentionsSmartInbox/mentionsTimeline",
  //       isVisible: true,
  //     },
  //     { isValid: true, route: "/brandintel/dashboard", isVisible: true },
  //     { isValid: true, route: "/portfolio/trackcompanies", isVisible: true },
  //     { isValid: true, route: "/profile", isVisible: true },
  //   ],
  // },
  // {
  //   id: "10",
  //   icon: "hubspot",
  //   label: "Hubspot",
  //   state: [
  //     { isValid: true, route: "/portfolio/trackcompanies", isVisible: true },
  //     { isValid: true, route: "/profile", isVisible: true },
  //   ],
  // },
];

export const MEDIA_DATA = [
  {
    id: 1,
    label: 'Microsoft Org',
    image: '',
    isVerified: 'true',
  },
  {
    id: 2,
    label: 'Microsoft Org1',
    image: '',
    isVerified: 'false',
  },
];

export const SIDEBAR_MAPPING = [
  // {
  //   id: 3,
  //   label: 'omniO AI Assistant',
  //   svg: '<svg viewBox="0 0 512 512" width="22px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>ai</title> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="icon" fill="#E2E8F0" transform="translate(64.000000, 64.000000)"> <path d="M320,64 L320,320 L64,320 L64,64 L320,64 Z M171.749388,128 L146.817842,128 L99.4840387,256 L121.976629,256 L130.913039,230.977 L187.575039,230.977 L196.319607,256 L220.167172,256 L171.749388,128 Z M260.093778,128 L237.691519,128 L237.691519,256 L260.093778,256 L260.093778,128 Z M159.094727,149.47526 L181.409039,213.333 L137.135039,213.333 L159.094727,149.47526 Z M341.333333,256 L384,256 L384,298.666667 L341.333333,298.666667 L341.333333,256 Z M85.3333333,341.333333 L128,341.333333 L128,384 L85.3333333,384 L85.3333333,341.333333 Z M170.666667,341.333333 L213.333333,341.333333 L213.333333,384 L170.666667,384 L170.666667,341.333333 Z M85.3333333,0 L128,0 L128,42.6666667 L85.3333333,42.6666667 L85.3333333,0 Z M256,341.333333 L298.666667,341.333333 L298.666667,384 L256,384 L256,341.333333 Z M170.666667,0 L213.333333,0 L213.333333,42.6666667 L170.666667,42.6666667 L170.666667,0 Z M256,0 L298.666667,0 L298.666667,42.6666667 L256,42.6666667 L256,0 Z M341.333333,170.666667 L384,170.666667 L384,213.333333 L341.333333,213.333333 L341.333333,170.666667 Z M0,256 L42.6666667,256 L42.6666667,298.666667 L0,298.666667 L0,256 Z M341.333333,85.3333333 L384,85.3333333 L384,128 L341.333333,128 L341.333333,85.3333333 Z M0,170.666667 L42.6666667,170.666667 L42.6666667,213.333333 L0,213.333333 L0,170.666667 Z M0,85.3333333 L42.6666667,85.3333333 L42.6666667,128 L0,128 L0,85.3333333 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>',
  //   icon: '<svg viewBox="0 0 512 512" width="22px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>ai</title> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="icon" fill="#E2E8F0" transform="translate(64.000000, 64.000000)"> <path d="M320,64 L320,320 L64,320 L64,64 L320,64 Z M171.749388,128 L146.817842,128 L99.4840387,256 L121.976629,256 L130.913039,230.977 L187.575039,230.977 L196.319607,256 L220.167172,256 L171.749388,128 Z M260.093778,128 L237.691519,128 L237.691519,256 L260.093778,256 L260.093778,128 Z M159.094727,149.47526 L181.409039,213.333 L137.135039,213.333 L159.094727,149.47526 Z M341.333333,256 L384,256 L384,298.666667 L341.333333,298.666667 L341.333333,256 Z M85.3333333,341.333333 L128,341.333333 L128,384 L85.3333333,384 L85.3333333,341.333333 Z M170.666667,341.333333 L213.333333,341.333333 L213.333333,384 L170.666667,384 L170.666667,341.333333 Z M85.3333333,0 L128,0 L128,42.6666667 L85.3333333,42.6666667 L85.3333333,0 Z M256,341.333333 L298.666667,341.333333 L298.666667,384 L256,384 L256,341.333333 Z M170.666667,0 L213.333333,0 L213.333333,42.6666667 L170.666667,42.6666667 L170.666667,0 Z M256,0 L298.666667,0 L298.666667,42.6666667 L256,42.6666667 L256,0 Z M341.333333,170.666667 L384,170.666667 L384,213.333333 L341.333333,213.333333 L341.333333,170.666667 Z M0,256 L42.6666667,256 L42.6666667,298.666667 L0,298.666667 L0,256 Z M341.333333,85.3333333 L384,85.3333333 L384,128 L341.333333,128 L341.333333,85.3333333 Z M0,170.666667 L42.6666667,170.666667 L42.6666667,213.333333 L0,213.333333 L0,170.666667 Z M0,85.3333333 L42.6666667,85.3333333 L42.6666667,128 L0,128 L0,85.3333333 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>',
  //   route: '/haix-genai',
  //   child: [
  //     {
  //       id: 20,
  //       label: 'HaiX AI Social Insights',
  //       icon: 'travel_explore',
  //       route: '/summary',
  //     },
  //   ],
  // },
  {
    id: 137,
    label: 'Manage Subscription',
    icon: 'person',
    route: '/profile/subscription',
  },

  {
    id: 3,
    label: 'Brand & Market Intel Hub',
    // icon: 'equalizer',
    icon: 'auto_graph',
    route: '/brandintel',
    child: [
      //  {
      //   id: 133,
      //   label: "Favourites Dashboard",
      //   icon: "dashboard",
      //   route: "/favouritesdashboard",
      // },

      {
        id: 15,
        label: 'Brand & Market Insights Dashboard',
        // icon: 'auto_graph',
        icon: 'data_exploration',
        route: '/dashboard',
      },
      {
        id: 14,
        label: 'Comparison hub',
        icon: 'dashboard',
        route: '/comparisonhub',
      },

      {
        id: 14,
        label: 'Comparison hub (SMB)',
        icon: 'dashboard',
        route: '/_comparisonhubsmb',
      },

      {
        id: 13,
        label: 'Manage Brands/ Topics',
        icon: 'groups',
        route: '/trackcompanies',
      },
      {
        id: 1380,
        label: 'Trend Dashboard',
        icon: 'groups',
        route: '/google-trends',
      },
    ],
  },
  {
    id: 4,
    label: 'LinkedIn Intel Hub',
    svg: '<svg xmlns=http://www.w3.org/2000/svg" width="22px" style="fill:#E2E8F0"  fill="slate-500" viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>',
    icon: '<svg xmlns=http://www.w3.org/2000/svg" width="22px" style="fill:#E2E8F0;"  fill="slate-500"  viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>',
    route: '/linkedin',
    child: [
      {
        id: 11,
        label: 'Linkedin Insights Dashboard',
        icon: 'person',
        route: '/insights',
      },
      {
        id: 10,
        label: 'LinkedIn owned-account Insights',
        icon: 'people_alt',
        route: '/owned-account',
      },
      // {
      //   id: 12,
      //   label: "LinkedIn User Insights",
      //   icon: "person",
      //   route: "/user",
      // },
    ],
  },

  {
    id: 1,
    label: 'Real-time Social Insights search',
    icon: 'manage_search',
    route: '/',
    child: [
      {
        id: 6,
        label: 'Social Insights Dashboard',
        icon: 'dashboard',
        route: 'socialinsights',
      },
    ],
  },
  {
    id: 30,
    label: 'Favourites Dashboard',
    icon: 'star',
    route: '/favouritesdashboard',
  },

  {
    id: 0,
    label: 'Alerts',
    icon: 'notifications',
    route: '/alerts',
  },

  {
    id: 22,
    label: `Gen AI social media search`,
    icon: 'dashboard',
    route: '/genai-live',
  },

  // {
  //   id: 22,
  //   label: `Gen AI Live Chat `,
  //   icon: 'dashboard',
  //   route: '/genai-live',
  // },

  {
    id: 2,
    label: 'Lead Generation Insights',
    icon: 'person',
    route: '/lead',
    child: [
      // {
      //   id: 17,
      //   label: "Lead Insights",
      //   icon: "travel_explore",
      //   route: "/generation",
      // },

      // {
      //   id: 19,
      //   label: "Manage Leads Links",
      //   icon: "travel_explore",
      //   route: "/managelink",
      // },

      {
        id: 21,
        label: 'Lead Insights',
        icon: 'person',
        route: '/salesleadinsights',
      },
      {
        id: 20,
        label: 'Social Media Lead Insights',
        icon: 'travel_explore',
        route: '/socialmediainsights',
      },
      {
        id: 18,
        label: 'Job Insights',
        icon: 'travel_explore',
        route: '/jobinsights',
      },
      // {
      //   id: 20,
      //   label: "Show Lead",
      //   icon: "travel_explore",
      //   route: "/showlead",
      // },
    ],
  },

  {
    id: 5,
    label: 'Company Intelligence',
    icon: 'corporate_fare',
    route: '/companyinsights',
    child: [
      {
        id: 1,
        label: 'Company Insights',
        icon: 'dashboard',
        route: '/companydetails',
      },
    ],
  },

  {
    id: 2,
    label: 'Trust Pilot Insights',
    svg: '<svg style="fill: #E2E8F0;" height="22px" width="22px"  viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>Trustpilot icon</title><path d="M12,17.964l5.214-1.321l2.179,6.714L12,17.964z M24,9.286h-9.179L12,0.643L9.179,9.286 H0l7.429,5.357l-2.821,8.643l7.429-5.357l4.571-3.286L24,9.286L24,9.286L24,9.286L24,9.286z"></path></g></svg>',
    icon: 'stars',
    route: '/trustpilot',
    child: [
      {
        id: 17,
        label: 'Trustpilot Insights',
        icon: 'travel_explore',
        route: '/',
      },
    ],
  },
  {
    id: 6,
    label: 'Marketing Campaign Insights',
    svg: '<svg style="fill: #E2E8F0;" height="22px" width="22px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 29.94 29.94" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M27.56,0.684H2.383C1.065,0.684,0,1.748,0,3.064v23.813c0,1.312,1.065,2.379,2.383,2.379H27.56 c1.312,0,2.38-1.066,2.38-2.379V3.064C29.939,1.748,28.871,0.684,27.56,0.684z M20.125,9.167c-0.619-0.362-1.11-0.648-1.727-0.648 c-0.604,0-1.12,0.151-1.384,0.405c-0.264,0.252-0.395,0.74-0.395,1.461v1.067h3.229l-0.699,2.968h-2.53v9.862h-4.056V14.42H10.67 v-2.968h1.895v-1.133c0-1.193,0.143-1.907,0.425-2.496c0.281-0.587,0.826-1.241,1.584-1.611c0.757-0.369,1.877-0.555,3.036-0.555 c1.188,0,2.116,0.396,3.254,0.715L20.125,9.167z"></path> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>',
    icon: '<svg style="fill: #E2E8F0;" height="22px" width="22px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 29.94 29.94" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M27.56,0.684H2.383C1.065,0.684,0,1.748,0,3.064v23.813c0,1.312,1.065,2.379,2.383,2.379H27.56 c1.312,0,2.38-1.066,2.38-2.379V3.064C29.939,1.748,28.871,0.684,27.56,0.684z M20.125,9.167c-0.619-0.362-1.11-0.648-1.727-0.648 c-0.604,0-1.12,0.151-1.384,0.405c-0.264,0.252-0.395,0.74-0.395,1.461v1.067h3.229l-0.699,2.968h-2.53v9.862h-4.056V14.42H10.67 v-2.968h1.895v-1.133c0-1.193,0.143-1.907,0.425-2.496c0.281-0.587,0.826-1.241,1.584-1.611c0.757-0.369,1.877-0.555,3.036-0.555 c1.188,0,2.116,0.396,3.254,0.715L20.125,9.167z"></path> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>',
    route: '/ad',
    child: [
      {
        id: 7,
        label: 'Facebook Ad Insights',
        icon: 'ads_click',
        route: '/facebook',
      },
      {
        id: 8,
        label: 'Facebook Campaign Ad Trends',
        icon: 'timeline',
        route: '/trends',
      },
      {
        id: 9,
        label: 'Bot Stats',
        icon: 'query_stats',
        route: '/botstats',
      },
    ],
  },
  // {
  //   id: 7,
  //   label: "Active Influencers Insights",
  //   icon: "insights",
  //   route: "/influencers",
  //   child: [
  //     {
  //       id: 17,
  //       label: "Active Followers",
  //       icon: "dashboard",
  //       route: "/activeFollowers",
  //     },
  //     {
  //       id: 19,
  //       label: "Active Influencers",
  //       icon: "dashboard",
  //       route: "/activeInfluencers",
  //     },
  //   ],
  // },
  // {
  //   id: 10,
  //   label: "Social Mentions Smart Inbox",
  //   icon: "insights",
  //   route: "/socialMentionsSmartInbox",
  //   child: [
  //     {
  //       id: 21,
  //       label: "Social Comments Timeline",
  //       icon: "dashboard",
  //       route: "/mentionsTimeline",
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   label: "Real time HaiX AI Insights [beta]",
  //   icon: "location_searching",
  //   route: "/gpt",
  //   child: [
  //     {
  //       id: 19,
  //       label: "HaiX Real Time ChatGPT",
  //       icon: "chatGpt_playground",
  //       route: "/chatGpt_prompts",
  //     },
  //     {
  //       id: 18,
  //       label: "GPT Playground",
  //       icon: "chatGpt_playground",
  //       route: "/chatGpt",
  //     },
  //   ],
  // },

  {
    id: 2,
    label: 'Admin',
    icon: 'admin_panel_settings',
    route: '/excell',
    child: [
      {
        id: 20,
        label: 'Manage Subscription',
        icon: 'travel_explore',
        route: '/uploadlist',
      },
      {
        id: 21,
        label: 'Token Usage',
        icon: 'token',
        route: '/token-usage',
      },
    ],
  },

  {
    id: 33,
    label: 'Utility Functions',
    icon: 'manage_search',
    route: '/genai-insights',
  },

  {
    id: 3,
    label: 'PDF Copilot Assistant',
    icon: 'picture_as_pdf',
    route: '/upload-pdf',
  },

  {
    id: 391,
    label: 'Audience Research Insights',
    icon: 'groups',
    route: '/Audience-Research-Insights',
  },

  {
    id: 392,
    label: 'Audience Research Dashboard',
    icon: 'groups',
    route: '/Research-Insights',
  },

  // {
  //   id: 3,
  //   label: 'Our happy clients',
  //   icon: 'comment',
  //   route: '/testimonial',
  // },

  // {
  //   id: 6,
  //   label: "Intelligent Real Time AI Neural Search",
  //   icon: "location_searching",
  //   route: "/neural",
  //   child: [
  //     {
  //       id: 16,
  //       label: "Real Time AI Semantic Search",
  //       icon: "travel_explore",
  //       route: "/search",
  //     },
  //   ],
  // },
];

export const SENTIMENT_AS_CATEGORIES = {
  twitter: {
    // Use external tweet counts so chart matches drilldown table
    positive: 'positiveExternalTweets',
    negative: 'negativeExternalTweets',
    neutral: 'neutralExternalTweets',
  },
  reddit: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
  facebook: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
  articles: {
    positive: 'positiveArticles',
    negative: 'negativeArticles',
    neutral: 'neutralArticles',
  },
  youtube: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
  instagram: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
  tiktok: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
  linkedin: {
    positive: 'positiveComments',
    negative: 'negativeComments',
    neutral: 'neutralComments',
  },
};
export const HASHTAG_AS_CATEGORIES = {
  twitter: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  reddit: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  facebook: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  articles: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  youtube: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  instagram: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  tiktok: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
  linkedin: {
    positive: 'positiveHashtags',
    negative: 'negativeHashtags',
    neutral: 'neutralHashtags',
  },
};
export const LANGUAGES_METADATA = [
  {
    value: 'en',
    language: 'English',
  },
  {
    value: 'es',
    language: 'Spanish',
  },
  {
    value: 'fr',
    language: 'French',
  },
  {
    value: 'it',
    language: 'Italian',
  },
  {
    value: 'ar',
    language: 'Arabic',
  },
];

export const YOUTUBE_OPTIONS = ['channel', 'keyword'];
export const INSTAGRAM_OPTIONS = [
  'manual_users',
  'manual_hashtags',
  'manual_tags',
];
export const TIKTOK_OPTIONS = ['userposts', 'userhashtags', 'keywordposts'];
export const TWITTER_OPTIONS = ['handler', 'keyword'];

// export const MEDIA_TAB_MAPPING = {
//   youtube: [
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Aspect Sentiment", route: "/aspectSentiment" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Sentiment By Category", route: "/sentimentByCategories" },
//   ],
//   facebook: [
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Aspect Sentiment", route: "/aspectSentiment" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Sentiment By Category", route: "/sentimentByCategories" },
//     { label: "Engagements", route: "/engagements" },
//   ],
//   instagram: [
//     { label: "Top Followers", route: "/topFollowers" },
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Sentiment By Category", route: "/sentimentByCategories" },
//     { label: "Engagements", route: "/engagements" },
//     { label: "Stats", route: "/stats" },
//     { label: "Active Followers", route: "/topInfluencers" },
//   ],
//   reddit: [
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Aspect Sentiment", route: "/aspectSentiment" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Sentiment By Category", route: "/sentimentByCategories" },
//   ],
//   twitter: [
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Aspect Sentiment", route: "/aspectSentiment" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Sentiment By Category", route: "/sentimentByCategories" },
//     { label: "Engagements", route: "/engagements" },
//     { label: "Top Categories", route: "/topCategories" },
//   ],
//   news: [
//     { label: "Top Hashtags", route: "/topHashtags" },
//     { label: "Top Entities", route: "/topEntities" },
//     { label: "Sentiment Trend", route: "/sentimentTrend" },
//     { label: "Aspect Sentiment", route: "/aspectSentiment" },
//     { label: "Post Insights", route: "/postInsights" },
//     { label: "Engagements", route: "/engagements" },
//   ],
// };

export const TAB_DATA = {
  topHashtags: 'Top Hashtags',
  location: 'Audience demographics',
  topEntities: 'Top Entities',
  sentimentCard: 'Sentiment Score',
  sentimentTrend: 'Sentiment Trend',
  audienceInsights: 'Content Type - Share of Voice',
  engagementPercentageTrend: 'Engagement Percentage Trend',
  aspectSentiment: 'Aspect Sentiment',
  mentionsTimeline: 'Vision Insights and Mentions (Posts & Comments)',
  // 'Vision Insights and Mentions (Posts & Comments)',
  topComments: 'All Comments',
  mentionsTimelineSummary: 'Engagement Trend Summary ',
  mentionsTimelineHistory: 'Post Timeline Trend',
  showLead: 'Show Lead',
  sentimentByCategory: 'Sentiment By Category',
  followersTimeline: 'Followers Timeline',
  stats: 'Stats',
  activeFollowers: 'Active Followers',
  activeUsers: 'Active Users',
  topCategories: 'Top Categories',
  topFollowers: 'Top Followers',
  followersDemographic: 'Followers Demographic',
  userActiveTimeline: 'Users Active Timeline',
  audienceInsights: 'Content Type - Share of Voice',
  emotionInsights: 'Emotion Insights',
  topInfluencers: 'Top Audience/Influencers',
  engagementStats: 'Engagement Stats',
  userActivity: 'User Activity',
  topInfluencersRanking: 'Top Influencers Ranking',
  imageAnalysisRanking: 'Top Image Categories',
  imageAnalysisTrend: 'Image Categories Trend',
  hashtagTrend: 'Hashtag Trend',
  userHashtags: 'User Hashtags',
  aspectSentimentTrend: 'Aspect Sentiment Trend',
  topEntitiesTrend: 'Top Entities Trend',
  engagementEntries: 'Engagement Metrics Stats',
  followers: 'Followers',
  mentionsByLanguage: 'Posts/Comments by Language',
  mentionsBySentimentType: 'Sentiment by Categories',
};
export const ACTIVE_INFLUENCERS_TAB_DATA = {
  followersReach: 'Followers Reach',
  followersTrend: 'Followers Trend',
  followersTimeline: 'Followers Timeline',
  followersStats: 'Followers Stats',
  influencerStats: 'Influencer Stats',
};

export const LoaderMessage =
  'Our AI is generating insights from millions of social media data';
export const ACTIVE_FOLLOWERS_TAB_MAPPING = {
  twitter: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
  instagram: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
  tiktok: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
  reddit: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
  facebook: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
  articles: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Follower Stats',
  ],
  youtube: [
    'Followers Trend',
    'Followers Timeline',
    'Followers Reach',

    'Followers Stats',
  ],
};

export const ACTIVE_INFLUENCERS_TAB_MAPPING = {
  twitter: ['Influencer Stats'],
  instagram: ['Influencer Stats', 'Top Audience/Influencers Ranking'],
  tiktok: ['Influencer Stats', 'Top Influencers Ranking'],
  reddit: [
    //"Influencer Stats",
  ],
  facebook: [
    //"Influencer Stats",
  ],
  articles: [
    //"Influencer Stats",
  ],
  youtube: [
    //"Influencer Stats",
  ],
};

export const MENTIONS_TIMELINE_TAB_MAPPING = {
  twitter: ['Comments Timeline', 'Show Lead'],
  instagram: ['Comments Timeline', 'Show Lead'],
  tiktok: ['Comments Timeline', 'Show Lead'],
  reddit: ['Comments Timeline', 'Show Lead'],
  facebook: ['Comments Timeline', 'Show Lead'],
  articles: ['Comments Timeline', 'Show Lead'],
  youtube: ['Comments Timeline', 'Show Lead'],
};

export const MENTIONS_TIMELINE_PILLS_MAPPING = {
  tag: [
    {
      label: 'Spam',
      value: 'spam',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Issue',
      value: 'issue',
      color: 'text-[#1995EF]',
      isActive: false,
    },
    {
      label: 'Complaint',
      value: 'complaint',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
    {
      label: 'Appreciation',
      value: 'appreciation',
      color: 'text-[#49AE55]',
      isActive: false,
    },
  ],
  flag: [
    {
      label: 'Positive',
      value: 'positive',
      color: 'text-[#49AE55]',
      isActive: false,
    },
    {
      label: 'Negative',
      value: 'negative',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Neutral',
      value: 'neutral',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
  ],
  lead: [
    {
      label: 'Spam',
      value: 'spam',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Top Lead',
      value: 'topLead',
      color: 'text-[#1995EF]',
      isActive: false,
    },
    {
      label: 'Known Lead',
      value: 'knownLead',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
    {
      label: 'Not a Lead',
      value: 'notALead',
      color: 'text-[#49AE55]',
      isActive: false,
    },
  ],
  jobtype: [
    {
      label: 'High',
      value: 'high',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Medium',
      value: 'medium',
      color: 'text-[#1995EF]',
      isActive: false,
    },
    {
      label: 'Low',
      value: 'low',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
  ],
};

export const MENTIONS_TIMELINE_FILTER_PILLS_MAPPING = {
  tag: [
    {
      label: 'All Posts',
      value: 'allPost',
      color: 'text-[#F44235]',
      isActive: true,
    },
    {
      label: 'No Marked',
      value: 'notag',
      color: 'text-[#F44235]',
      isActive: true,
    },
    {
      label: 'Spam',
      value: 'spam',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Issue',
      value: 'issue',
      color: 'text-[#1995EF]',
      isActive: false,
    },
    {
      label: 'Complaint',
      value: 'complaint',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
    {
      label: 'Appreciation',
      value: 'appreciation',
      color: 'text-[#49AE55]',
      isActive: false,
    },
  ],
  flag: [
    {
      label: 'All Posts',
      value: 'allposts',
      color: 'text-[#F44235]',
      isActive: true,
    },
    {
      label: 'Positive',
      value: 'positive',
      color: 'text-[#49AE55]',
      isActive: false,
    },
    {
      label: 'Negative',
      value: 'negative',
      color: 'text-[#F44235]',
      isActive: false,
    },
    {
      label: 'Neutral',
      value: 'neutral',
      color: 'text-[#FFEA4C]',
      isActive: false,
    },
  ],
};
export const MENTIONS_TIMELINE_LEAD_BY_TABLE_SORTBY_OPTION = [
  { label: 'All Posts', value: 'allPostsOption', isActive: true },
  {
    label: 'Not Marked',
    value: 'notmarked',
    isActive: true,
  },
  { label: 'Spam', value: 'spam', isActive: false },
  { label: 'Top Lead', value: 'topLead', isActive: false },
  { label: 'Known Lead', value: 'knownLead', isActive: false },
  { label: 'Not A Lead', value: 'notALead', isActive: false },
];
// 23/1/23 - user active timeline turned off for fb
export const MEDIA_TAB_MAPPING = {
  youtube: [
    'Posts/Comments by Language',

    // "Followers Timeline", // TODO:: check data is present or not
    'Sentiment Trend',
    'Engagement Trend Summary ',
    'Top Hashtags',
    'Users Active Timeline',

    'All Comments',
    'Vision Insights and Mentions (Posts & Comments)',
    'Audience demographics',

    'Top Entities',
    'Aspect Sentiment',
    'Post Timeline Trend',
    'Top Audience/Influencers',
    'Active Followers',
    'Engagement Percentage Trend',
    'Hashtag Trend',
    'Top Entities Trend',
    'Aspect Sentiment Trend',
    'Emotion Insights',

    // "Top Influencers", check if usernames are comming to get Influencers and followers
    // "Top Influencers Ranking", check if usernames are comming to get Influencers and followers

    // "Sentiment By Category",
  ],
  facebook: {
    userpost: [
      'Posts/Comments by Language',


      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Engagement Percentage Trend',
      'Post Timeline Trend',
      'Aspect Sentiment Trend',
      'Hashtag Trend',
      'Top Entities Trend',

      // To bring Top Image Categories api from backend.

      // "Top Influencers", facebook doesn't provide usernames to get Influencers and followers
      // "Top Influencers Ranking", facebook doesn't provide usernames to get Influencers and followers
      // "Active Followers", facebook doesn't provide usernames to get Influencers and followers

      // "Sentiment By Category",
    ],
    keywords: [
      'Posts/Comments by Language',

      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',
      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Engagement Percentage Trend',
      'Post Timeline Trend',
      'Aspect Sentiment Trend',
      'Hashtag Trend',
      'Top Entities Trend',

      // To bring Top Image Categories api from backend.

      // "Top Influencers", facebook doesn't provide usernames to get Influencers and followers
      // "Top Influencers Ranking", facebook doesn't provide usernames to get Influencers and followers
      // "Active Followers", facebook doesn't provide usernames to get Influencers and followers

      // "Sentiment By Category",
    ],
  },
  instagram: {
    manual_users: [
      'Posts/Comments by Language',

      'Sentiment Trend',
      // "Followers Timeline",
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Followers',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Active Followers',
      'Engagement Percentage Trend',
      'Engagement Metrics Stats',
      'Hashtag Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',
      'Top Entities Trend',
      'Emotion Insights',

      // "Top Influencers", own account don't have Influencers
      // "Top Influencers Ranking", own account don't have Influencers

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],

    manual_tags: [
      // "Followers Timeline",
      'Posts/Comments by Language',

      'Sentiment Trend',
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Engagement Percentage Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Hashtag Trend',
      'Top Entities Trend',
      'Aspect Sentiment Trend',
      'Image Categories Trend',
      'Emotion Insights',

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],
    manual_hashtags: [
      // "Followers Timeline",
      'Posts/Comments by Language',

      'Sentiment Trend',
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Engagement Percentage Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Hashtag Trend',
      'Top Entities Trend',
      'Aspect Sentiment Trend',
      'Image Categories Trend',
      'Emotion Insights',

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],
    manual_keywords: [
      // "Followers Timeline",
      'Posts/Comments by Language',

      'Sentiment Trend',
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Engagement Percentage Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Hashtag Trend',
      'Top Entities Trend',
      'Aspect Sentiment Trend',
      'Image Categories Trend',
      'Emotion Insights',

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],
  },
  tiktok: {
    userposts: [
      'Posts/Comments by Language',

      'Sentiment Trend',

      'Content Type - Share of Voice',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',
      'Followers',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Active Followers',
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'Top Entities Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',
      'Sentiment by Categories',

      // "Emotion Insights",
      // "Followers Demographic",

      // "Top Influencers", own account don't have Influencers
      // "Top Influencers Ranking", own account don't have Influencers

      // "Sentiment By Category",
      // "Engagement Stats",
      // "User Activity",
    ],
    userhashtags: [
      'Posts/Comments by Language',

      // "Followers Timeline",
      // "Followers Demographic",
      'Sentiment Trend',
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'User Hashtags',
      'Top Entities Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',

      // "Sentiment By Category",

      'Emotion Insights',
    ],
    keywordposts: [
      'Posts/Comments by Language',

      'Sentiment Trend',
      'Content Type - Share of Voice',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Users Active Timeline',

      'All Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'Top Entities Trend',
      'Image Categories Trend',
      // Active Followers missing

      'Emotion Insights',
      // "Aspect Sentiment Trend",
    ],
  },
  reddit: [
    'Posts/Comments by Language',

    'Sentiment Trend',
    'Engagement Trend Summary ',
    'Top Hashtags',
    'Users Active Timeline',

    'All Comments',
    'Vision Insights and Mentions (Posts & Comments)',

    'Top Entities',
    'Aspect Sentiment',
    'Top Image Categories',
    'Post Timeline Trend',
    'Active Followers',
    'Hashtag Trend',
    'Top Entities Trend',
    'Aspect Sentiment Trend',
    'Image Categories Trend',
    'Emotion Insights',
    // "Top Influencers Ranking missing",
    // "Top Influencers missing",
    // "Sentiment By Category",
  ],
  twitter: [
    'Posts/Comments by Language',

    'Sentiment Trend',
    'Content Type - Share of Voice',
    // "Followers Timeline",
    'Engagement Trend Summary ',
    'Top Hashtags',
    'Users Active Timeline',

    // "All Mentions",
    'Vision Insights and Mentions (Posts & Comments)',

    'Top Entities',
    'Aspect Sentiment',
    'Post Timeline Trend',
    'Active Followers',
    'Top Audience/Influencers',
    'Engagement Percentage Trend',
    'Hashtag Trend',
    'Top Entities Trend',
    'Aspect Sentiment Trend',
    'Emotion Insights',
    'Audience demographics',
    // "Sentiment By Category",
    // "Top Categories",
    // "Top Influencers Ranking missing",
    // "Top Influencers missing",
  ],
  articles: [
    'Posts/Comments by Language',

    // "Followers Timeline",
    'Sentiment Trend',
    'Engagement Trend Summary ',
    'Vision Insights and Mentions (Posts & Comments)',
    'Users Active Timeline',

    'Top Entities',
    'Aspect Sentiment',

    'Top Entities Trend',
    'Post Timeline Trend',
    'Top Hashtags',
    'Engagement Percentage Trend',
    'Hashtag Trend',
  ],
};

export const MEDIA_TAB_MAPPING_COMPARISION_PAGE = {
  forAllSocialMedia: [
    // "Followers Timeline", // TODO:: check data is present or not
    'Content Type - Share of Voice',
    'Vision Insights and Mentions (Posts & Comments)',
    'Top Comments',

  ],

  forComparisionDashboardNew: [
    // "Followers Timeline", // TODO:: check data is present or not
    'Total Followers',
    'Follower Stats Comparison',
    'Sentiments Score',
    'Engagement Trend Summary',
    'Content Type - Share of Voice',
  ],
  comparisionSummary: [
    'Total Followers',
    'Follower Stats Comparison',
    'Sentiments Score',
    'Total Comments',
    'Sentiment Timeline',
    'Sentiment Trend',
    'Posts/Comments by Language',
    'Top Hashtags',
    'Top Entities',
    'Aspect Sentiment',
  ],

  summaryStats: [
    'Posts/Comments by Language',
    'Sentiment Timeline',
    'Top Hashtags',
    'Comments Insights',
    'Audience demographics',
    'Audience Geography',

    'Vision Insights and Mentions (Posts & Comments)',
    'All Comments',

    // 'Sentiment by Categories',
    'Top Audience/Influencers',
    'Followers Stats',


  ],
  facebook: {
    userpost: [
      'Users Active Timeline',
      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Engagement Percentage Trend',
      'Post Timeline Trend',
      'Aspect Sentiment Trend',
      'Hashtag Trend',
      'Top Entities Trend',

      // To bring Top Image Categories api from backend.

      // "Top Influencers", facebook doesn't provide usernames to get Influencers and followers
      // "Top Influencers Ranking", facebook doesn't provide usernames to get Influencers and followers
      // "Active Followers", facebook doesn't provide usernames to get Influencers and followers

      // "Sentiment By Category",
    ],
    keywords: [
      'Users Active Timeline',
      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',

      'Top Entities',
      'Aspect Sentiment',
      'Engagement Percentage Trend',
      'Post Timeline Trend',
      'Aspect Sentiment Trend',
      'Hashtag Trend',
      'Top Entities Trend',

      // To bring Top Image Categories api from backend.

      // "Top Influencers", facebook doesn't provide usernames to get Influencers and followers
      // "Top Influencers Ranking", facebook doesn't provide usernames to get Influencers and followers
      // "Active Followers", facebook doesn't provide usernames to get Influencers and followers

      // "Sentiment By Category",
    ],
  },
  instagram: {
    manual_users: [
      'Users Active Timeline',
      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',
      'Followers',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Active Followers',
      'Engagement Percentage Trend',
      'Engagement Metrics Stats',
      'Hashtag Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',
      'Top Entities Trend',
      'Emotion Insights',

      // "Top Influencers", own account don't have Influencers
      // "Top Influencers Ranking", own account don't have Influencers

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],

    manual_tags: [
      // "Followers Timeline",
      'Users Active Timeline',
      'Sentiment Trend',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Engagement Percentage Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Hashtag Trend',
      'Top Entities Trend',
      'Aspect Sentiment Trend',
      'Image Categories Trend',
      'Emotion Insights',

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],
    manual_hashtags: [
      // "Followers Timeline",
      'Users Active Timeline',
      'Sentiment Trend',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Engagement Percentage Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Hashtag Trend',
      'Top Entities Trend',
      'Aspect Sentiment Trend',
      'Image Categories Trend',
      'Emotion Insights',

      // "Sentiment By Category",
      // "Stats",

      // "Engagement Stats",
      // "User Activity",
    ],
  },
  tiktok: {
    userposts: [
      'Users Active Timeline',
      'Sentiment Trend',
      // "Followers Timeline",
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',
      'Followers',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Active Followers',
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'Top Entities Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',

      // "Emotion Insights",
      // "Followers Demographic",

      // "Top Influencers", own account don't have Influencers
      // "Top Influencers Ranking", own account don't have Influencers

      // "Sentiment By Category",
      // "Engagement Stats",
      // "User Activity",
    ],
    userhashtags: [
      // "Followers Timeline",
      // "Followers Demographic",
      'Users Active Timeline',
      'Sentiment Trend',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Active Followers',
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'User Hashtags',
      'Top Entities Trend',
      'Image Categories Trend',
      'Aspect Sentiment Trend',

      // "Sentiment By Category",

      'Emotion Insights',
    ],
    keywordposts: [
      'Users Active Timeline',
      'Sentiment Trend',
      'Engagement Trend Summary ',
      'Top Hashtags',
      'Top Comments',
      'Vision Insights and Mentions (Posts & Comments)',
      'Audience demographics',

      'Top Entities',
      'Aspect Sentiment',
      'Top Image Categories',
      'Post Timeline Trend',
      'Top Audience/Influencers',
      // "Top Influencers Ranking",
      'Engagement Percentage Trend',
      'Hashtag Trend',
      'Top Entities Trend',
      'Image Categories Trend',
      // Active Followers missing

      'Emotion Insights',
      // "Aspect Sentiment Trend",
    ],
  },
  reddit: [
    'Users Active Timeline',
    'Sentiment Trend',
    'Engagement Trend Summary ',
    'Top Hashtags',
    'Top Comments',
    'Vision Insights and Mentions (Posts & Comments)',

    'Top Entities',
    'Aspect Sentiment',
    'Top Image Categories',
    'Post Timeline Trend',
    'Active Followers',
    'Hashtag Trend',
    'Top Entities Trend',
    'Aspect Sentiment Trend',
    'Image Categories Trend',
    'Emotion Insights',
    // "Top Influencers Ranking missing",
    // "Top Influencers missing",
    // "Sentiment By Category",
  ],
  twitter: [
    'Users Active Timeline',
    'Sentiment Trend',
    // "Followers Timeline",
    'Engagement Trend Summary ',
    'Top Hashtags',
    // "Top Comments",
    'Vision Insights and Mentions (Posts & Comments)',
    'Posts/Comments by Language',
    'Top Entities',
    'Aspect Sentiment',
    'Post Timeline Trend',
    'Active Followers',
    'Engagement Percentage Trend',
    'Hashtag Trend',
    'Top Entities Trend',
    'Aspect Sentiment Trend',
    'Emotion Insights',
    'Audience demographics',
    // "Sentiment By Category",
    // "Top Categories",
    // "Top Influencers Ranking missing",
    // "Top Influencers missing",
  ],
  articles: [
    // "Followers Timeline",
    'Users Active Timeline',
    'Sentiment Trend',
    'Engagement Trend Summary ',
    'Vision Insights and Mentions (Posts & Comments)',
    'Top Entities',
    'Aspect Sentiment',
    'Posts/Comments by Language',
    'Top Entities Trend',
    'Post Timeline Trend',
    'Top Hashtags',
    'Engagement Percentage Trend',
    'Hashtag Trend',
  ],
};

export const INSTAGRAM_TAB_MAPPING = [
  {
    label: 'User-Account Insights',
    value: 'manual_users',
    route: '/userAccount',
  },
  { label: 'User-Tagged Insights', value: 'manual_tags', route: '/tagged' },
  { label: 'Hashtag Insights', value: 'manual_hashtags', route: '/hashtags' },
  {
    label: 'Keyword Insights',
    value: 'manual_keywords',
    route: '/manual_keywords',
  },
];
export const INSTAGRAM_TAB_MAPPINGHUB = [
  {
    label: 'User-Account Insights',
    value: 'userAccount',
    route: '/userAccount',
  },
  { label: 'User-Tagged Insights', value: 'userTag', route: '/tagged' },
  { label: 'Hashtag Insights', value: 'hashtag', route: '/hashtags' },
  {
    label: 'Keyword Insights',
    value: 'manual_keywords',
    route: '/manual_keywords',
  },
];

export const TIKTOK_TAB_MAPPING = [
  { label: 'User-Account Insights', value: 'userposts', route: '/userAccount' },
  { label: 'Hashtag Insights', value: 'userhashtags', route: '/hashtags' },
  { label: 'Keyword Insights', value: 'keywordposts', route: '/keywords' },
];

export const PLATFORM_TAB_MAPPING = {
  instagram: [
    { label: 'User-Account Insights', value: 'userAccount', route: '/userAccount' },
    { label: 'User-Tagged Insights', value: 'userTag', route: '/tagged' },
    { label: 'Hashtag Insights', value: 'hashtag', route: '/hashtags' },
    { label: 'Keyword Insights', value: 'manual_keywords', route: '/manual_keywords' },
  ],
  tiktok: [
    { label: 'User-Account Insights', value: 'userAccount', route: '/userAccount' },
    { label: 'Hashtag Insights', value: 'hashtag', route: '/hashtags' },
    { label: 'Keyword Insights', value: 'manual_keywords', route: '/keywords' },
  ],
};
export const TIKTOK_TAB_MAPPINGHUB = [
  {
    label: 'User-Account Insights',
    value: 'userAccount',
    route: '/userAccount',
  },
  { label: 'Hashtag Insights', value: 'hashtag', route: '/hashtags' },
  { label: 'Keyword Insights', value: 'keyword', route: '/keywords' },
];
export const TIKTOK_TAB_MAPPINGKEY = {
  userposts: 'User-Account Insights',
  userhashtags: 'Hashtag Insights',
  keywordposts: 'Keyword Insights',
  manual_users: 'User-Account Insights',
  manual_tags: 'User-Tagged Insights',
  manual_hashtags: 'Hashtag Insights',
  manual_keywords: 'Keyword Insights',
};

// export const TIKTOK_TAB_MAPPING_OPTIONS = [
//   { label: 'User-Account Insights',value: route: '/userAccount' },
//   { label: 'Hashtag Insights', route: '/hashtags' },
//   { label: 'Keyword Insights', route: '/keywords' },
// ];

export const FACEBOOK_TAB_MAPPING = [
  { label: 'User-Account Insights', value: 0, route: '/userAccount' },
  { label: 'Keyword Insights', value: 1, route: '/keywords' },
];

export const YOUTUBE_TAB_MAPPING = [
  { label: 'Channel Insights', value: 'channel', route: '/userAccount' },
  { label: 'Keyword Insights', value: 'keyword', route: '/keywords' },
];

export const TOP_INFLUENCERS_SELECTION_OPTION = {
  negativeInfluencers: 'negativeInfluencers',
  neutralInfluencers: 'neutralInfluencers',
  positiveInfluencers: 'positiveInfluencers',
  totalInfluencers: 'Total Influencers',
};

export const SOCIAL_MEDIA_DATA_TYPE = {
  twitter: 'tweets',
  facebook: 'comments',
  instagram: 'comments',
  reddit: 'comments',
  tiktok: 'comments',
  youtube: 'comments',
  articles: 'articles',
  linkedin: 'comments',
};

export const ALERT_TYPE = [
  { label: 'Error', color: 'rose', id: 'error' },
  { label: 'Warning', color: 'amber', id: 'warning' },
  { label: 'Info', color: 'teal', id: 'info' },
];
export const NOTIFICATION_ALERT_TYPE = {
  error: 'error',
  warning: 'warning',
  info: 'info',
};
export const NOTIFICATION_ALERT_TEXT = {
  requiredFields: {
    companyAlert: 'Please fill the required fields in company alerts',
    companyCategories: 'Please fill the required fields in company categories',
  },
};

export const DIALOG_TYPE = {
  manageCompany: {
    delete: {
      title: 'Remove Company',
      body: 'Are you sure, you want to remove the company from your portfolio?',
      positiveButtonText: 'Cancel',
      negativeButtonText: 'Delete',
    },
    addNew: {
      title: 'Add Company',
      body: 'Limit Reached, Contact Team@haix.ai',
      positiveButtonText: 'Okay',
    },
    alert: {
      title: 'How to Enter Data',
      body: `1. For Keyword Detection Alert:\nMultiple  keywords is allowed (eg: refund, defect). It will create an alert if any of keyword is found in mentions.\n2. For Sentiment drop Alert:\nSpecify a value -1 (negative) to +1 (positive).\nEg: for a value 0.2, it will create an alert if the mean sentiment is less than this value.\n3. For Count Sentiment Alert:\nSpecify a count value (eg:10) and threshold sentiment value 0.2.\nEg: It will create an alert if Total Comments is greater than 10, which has sentiment value 0.2.`,
      positiveButtonText: 'Okay',
    },
    categories: {
      title: 'How to Enter Data',
      body: `A category is a group of similar keywords, given one name.

Example: a category named "shoes" holding sneakers, trainers, footwear.

How matching works:

We pull every post from the sources you set below. A post joins the category if ANY one of its keywords is found in the post — it does not need to match all of them. The same post can belong to more than one category.`,
      positiveButtonText: 'Okay',
    },
    filterKeywordButtons: {
      title: 'The Keyword Buttons',
      body: `Three ways to fill in Filter Keywords. All of them only suggest — nothing is saved until you save the row.

1. Search keywords based on category

Asks AI for keywords that fit this row, using the Category Name you set above. Suggestions appear as chips you can pick from. Needs a Category Name or a keyword already in the row.

The pencil next to it opens the prompt sent to the AI, so you can reword it. "Reset to default" puts the original back.

2. Search right keywords on social media (using AI)

Opens a generator where you enter the brand and focus area yourself, then returns keywords. Use this when you want to steer the result rather than have it read the category.

3. The platform icon

Opens that platform's own search in a new tab for the current keyword. Nothing is filled in for you — read what people actually post there, then type the keywords you want into the field.`,
      positiveButtonText: 'Okay',
    },
    saveData: {
      title: 'Unsaved Data',
      body: `Please save the data to proceed.`,
      positiveButtonText: 'Okay',
    },
    exitUnsavedData: {
      title: 'Unsaved Data',
      body: 'Are you sure, you want to exit?',
      positiveButtonText: 'No',
      negativeButtonText: 'Yes',
    },
  },
  manageSalesNavigator: {
    delete: {
      title: 'Remove Sales Navigator',
      body: 'Are you sure, you want to remove this Sales Navigator from your portfolio?',
      positiveButtonText: 'Cancel',
      negativeButtonText: 'Delete',
    },
  },
  manageJobSearches: {
    delete: {
      title: 'Remove Job Searches',
      body: 'Are you sure, you want to remove this Job Search from your portfolio?',
      positiveButtonText: 'Cancel',
      negativeButtonText: 'Delete',
    },
  },
  manageCompanyDetailSearches: {
    delete: {
      title: 'Remove Company Searches',
      body: 'Are you sure, you want to remove this Company Details from your portfolio?',
      positiveButtonText: 'Cancel',
      negativeButtonText: 'Delete',
    },
  },
  searchContainer: {
    limit: {
      title: (type) => {
        return `${type} Search`;
      },
      body: 'Search Limit Reached, Please contact team@omniosocial.com',
      positiveButtonText: 'Okay',
    },
  },
};

export const TIKTOK_SUBTAB_PILL_MAPPING = {
  userposts: [
    'Users Active Timeline',
    // "Followers Timeline",
    'Sentiment Trend',
    'Aspect Sentiment',
    // "Followers Demographic",
    'Top Hashtags',
    'Active Followers',
    // "Top Influencers",

    // "Sentiment By Category",
    'Top Entities',
    'Comments Timeline',
    'Emotion Insights',
    // "Engagement Stats",
    // "User Activity",
    // "Top Influencers Ranking",
  ],
  userhashtags: [
    // "Followers Timeline",
    // "Followers Demographic",
    'Users Active Timeline',
    'Sentiment Trend',
    'Aspect Sentiment',

    'Active Followers',
    'Top Hashtags',
    'Top Audience/Influencers',

    // "Sentiment By Category",
    'Top Entities',
    'Comments Timeline',
    'Emotion Insights',
    'Top Influencers Ranking',
  ],
  keywordposts: [
    'Users Active Timeline',
    'Sentiment Trend',
    'Aspect Sentiment',
    'Top Audience/Influencers',
    'Top Entities',
    'Top Hashtags',
    'Comments Timeline',
    'Emotion Insights',
    'Top Influencers Ranking',
  ],
};

export const LANGUAGES_LIST = [
  { language: 'Afar', code: 'aa' },
  { language: 'Abkhazian', code: 'ab' },
  { language: 'Afrikaans', code: 'af' },
  { language: 'Akan', code: 'ak' },
  { language: 'Amharic', code: 'am' },
  { language: 'Aragonese', code: 'an' },
  { language: 'Arabic', code: 'ar' },
  { language: 'Assamese', code: 'as' },
  { language: 'Avar', code: 'av' },
  { language: 'Aymara', code: 'ay' },
  { language: 'Azerbaijani', code: 'az' },
  { language: 'Bashkir', code: 'ba' },
  { language: 'Belarusian', code: 'be' },
  { language: 'Bulgarian', code: 'bg' },
  { language: 'Bihari', code: 'bh' },
  { language: 'Bislama', code: 'bi' },
  { language: 'Bambara', code: 'bm' },
  { language: 'Bengali', code: 'bn' },
  { language: 'Tibetan', code: 'bo' },
  { language: 'Breton', code: 'br' },
  { language: 'Bosnian', code: 'bs' },
  { language: 'Catalan', code: 'ca' },
  { language: 'Chechen', code: 'ce' },
  { language: 'Chamorro', code: 'ch' },
  { language: 'Corsican', code: 'co' },
  { language: 'Cree', code: 'cr' },
  { language: 'Czech', code: 'cs' },
  { language: 'Bulgarian', code: 'cu' },
  { language: 'Chuvash', code: 'cv' },
  { language: 'Welsh', code: 'cy' },
  { language: 'Danish', code: 'da' },
  { language: 'German', code: 'de' },
  { language: 'Divehi', code: 'dv' },
  { language: 'Dzongkha', code: 'dz' },
  { language: 'Ewe', code: 'ee' },
  { language: 'Greek', code: 'el' },
  { language: 'English', code: 'en' },
  { language: 'Esperanto', code: 'eo' },
  { language: 'Spanish', code: 'es' },
  { language: 'Estonian', code: 'et' },
  { language: 'Basque', code: 'eu' },
  { language: 'Persian', code: 'fa' },
  { language: 'Peul', code: 'ff' },
  { language: 'Finnish', code: 'fi' },
  { language: 'Fijian', code: 'fj' },
  { language: 'Faroese', code: 'fo' },
  { language: 'French', code: 'fr' },
  { language: 'West Frisian', code: 'fy' },
  { language: 'Irish', code: 'ga' },
  { language: 'Scottish Gaelic', code: 'gd' },
  { language: 'Galician', code: 'gl' },
  { language: 'Guarani', code: 'gn' },
  { language: 'Gujarati', code: 'gu' },
  { language: 'Manx', code: 'gv' },
  { language: 'Hausa', code: 'ha' },
  { language: 'Hebrew', code: 'he' },
  { language: 'Hindi', code: 'hi' },
  { language: 'Hiri Motu', code: 'ho' },
  { language: 'Croatian', code: 'hr' },
  { language: 'Haitian', code: 'ht' },
  { language: 'Hungarian', code: 'hu' },
  { language: 'Armenian', code: 'hy' },
  { language: 'Herero', code: 'hz' },
  { language: 'Interlingua', code: 'ia' },
  { language: 'Indonesian', code: 'id' },
  { language: 'Interlingue', code: 'ie' },
  { language: 'Igbo', code: 'ig' },
  { language: 'Sichuan Yi', code: 'ii' },
  { language: 'Inupiak', code: 'ik' },
  { language: 'Ido', code: 'io' },
  { language: 'Icelandic', code: 'is' },
  { language: 'Italian', code: 'it' },
  { language: 'Inuktitut', code: 'iu' },
  { language: 'Japanese', code: 'ja' },
  { language: 'Javanese', code: 'jv' },
  { language: 'Kongo', code: 'kg' },
  { language: 'Kikuyu', code: 'ki' },
  { language: 'Kuanyama', code: 'kj' },
  { language: 'Kazakh', code: 'kk' },
  { language: 'Greenlandic', code: 'kl' },
  { language: 'Cambodian', code: 'km' },
  { language: 'Kannada', code: 'kn' },
  { language: 'Korean', code: 'ko' },
  { language: 'Kanuri', code: 'kr' },
  { language: 'Kashmiri', code: 'ks' },
  { language: 'Kurdish', code: 'ku' },
  { language: 'Komi', code: 'kv' },
  { language: 'Cornish', code: 'kw' },
  { language: 'Kirghiz', code: 'ky' },
  { language: 'Latin', code: 'la' },
  { language: 'Luxembourgish', code: 'lb' },
  { language: 'Ganda', code: 'lg' },
  { language: 'Limburgian', code: 'li' },
  { language: 'Lingala', code: 'ln' },
  { language: 'Laotian', code: 'lo' },
  { language: 'Lithuanian', code: 'lt' },
  { language: 'Latvian', code: 'lv' },
  { language: 'Malagasy', code: 'mg' },
  { language: 'Marshallese', code: 'mh' },
  { language: 'Maori', code: 'mi' },
  { language: 'Macedonian', code: 'mk' },
  { language: 'Malayalam', code: 'ml' },
  { language: 'Mongolian', code: 'mn' },
  { language: 'Moldovan', code: 'mo' },
  { language: 'Marathi', code: 'mr' },
  { language: 'Malay', code: 'ms' },
  { language: 'Maltese', code: 'mt' },
  { language: 'Burmese', code: 'my' },
  { language: 'Nauruan', code: 'na' },
  { language: 'North Ndebele', code: 'nd' },
  { language: 'Nepali', code: 'ne' },
  { language: 'Ndonga', code: 'ng' },
  { language: 'Dutch', code: 'nl' },
  { language: 'Norwegian Nynorsk', code: 'nn' },
  { language: 'Norwegian', code: 'no' },
  { language: 'South Ndebele', code: 'nr' },
  { language: 'Navajo', code: 'nv' },
  { language: 'Chichewa', code: 'ny' },
  { language: 'Occitan', code: 'oc' },
  { language: 'Ojibwa', code: 'oj' },
  { language: 'Oromo', code: 'om' },
  { language: 'Oriya', code: 'or' },
  { language: 'Ossetian', code: 'os' },
  { language: 'Punjabi', code: 'pa' },
  { language: 'Pali', code: 'pi' },
  { language: 'Polish', code: 'pl' },
  { language: 'Pashto', code: 'ps' },
  { language: 'Portuguese', code: 'pt' },
  { language: 'Quechua', code: 'qu' },
  { language: 'Raeto Romance', code: 'rm' },
  { language: 'Kirundi', code: 'rn' },
  { language: 'Romanian', code: 'ro' },
  { language: 'Russian', code: 'ru' },
  { language: 'Rwandi', code: 'rw' },
  { language: 'Sanskrit', code: 'sa' },
  { language: 'Sardinian', code: 'sc' },
  { language: 'Sindhi', code: 'sd' },
  { language: 'Sango', code: 'sg' },
  { language: 'Serbo-Croatian', code: 'sh' },
  { language: 'Sinhalese', code: 'si' },
  { language: 'Slovak', code: 'sk' },
  { language: 'Slovenian', code: 'sl' },
  { language: 'Samoan', code: 'sm' },
  { language: 'Shona', code: 'sn' },
  { language: 'Somalia', code: 'so' },
  { language: 'Albanian', code: 'sq' },
  { language: 'Serbian', code: 'sr' },
  { language: 'Swati', code: 'ss' },
  { language: 'Southern Sotho', code: 'st' },
  { language: 'Sundanese', code: 'su' },
  { language: 'Swedish', code: 'sv' },
  { language: 'Swahili', code: 'sw' },
  { language: 'Tamil', code: 'ta' },
  { language: 'Telugu', code: 'te' },
  { language: 'Tajik', code: 'tg' },
  { language: 'Thai', code: 'th' },
  { language: 'Tigrinya', code: 'ti' },
  { language: 'Turkmen', code: 'tk' },
  { language: 'Tagalog', code: 'tl' },
  { language: 'Tswana', code: 'tn' },
  { language: 'Tonga', code: 'to' },
  { language: 'Turkish', code: 'tr' },
  { language: 'Tsonga', code: 'ts' },
  { language: 'Tatar', code: 'tt' },
  { language: 'Twi', code: 'tw' },
  { language: 'Tahitian', code: 'ty' },
  { language: 'Uyghur', code: 'ug' },
  { language: 'Urdu', code: 'ur' },
  { language: 'Venda', code: 've' },
  { language: 'Vietnamese', code: 'vi' },
  { language: 'Volapük', code: 'vo' },
  { language: 'Walloon', code: 'wa' },
  { language: 'Wolof', code: 'wo' },
  { language: 'Xhosa', code: 'xh' },
  { language: 'Yiddish', code: 'yi' },
  { language: 'Yoruba', code: 'yo' },
  { language: 'Zhuang', code: 'za' },
  { language: 'Chinese', code: 'zh' },
  { language: 'Zulu', code: 'zu' },
];

export const Language_Translate_TrailAcc = [
  { value: 'ace_Arab', label: 'Acehnese (Latin script)' },
  { value: 'ace_Latn', label: 'Arab' },
  { value: 'acm_Arab', label: 'Mesopotamian Arabic' },
  { value: 'acq_Arab', label: 'Ta’izzi-Adeni Arabic' },
  { value: 'aeb_Arab', label: 'Tunisian Arabic' },
  { value: 'afr_Latn', label: 'Afrikaans' },
  { value: 'ajp_Arab', label: 'South Levantine Arabic' },
  { value: 'aka_Latn', label: 'Akan' },
  { value: 'amh_Ethi', label: 'Amharic' },
  { value: 'apc_Arab', label: 'North Levantine Arabic' },
  { value: 'arb_Arab', label: 'Modern Standard Arabic' },
  { value: 'arb_Latn', label: 'Modern Standard Arabic (Romanized)' },
  { value: 'ars_Arab', label: 'Najdi Arabic' },
  { value: 'ary_Arab', label: 'Moroccan Arabic' },
  { value: 'arz_Arab', label: 'Egyptian Arabic' },
  { value: 'asm_Beng', label: 'Assamese' },
  { value: 'ast_Latn', label: 'Asturian' },
  { value: 'awa_Deva', label: 'Awadhi' },
  { value: 'ayr_Latn', label: 'Central Aymara' },
  { value: 'azb_Arab', label: 'South Azerbaijani' },
  { value: 'azj_Latn', label: 'North Azerbaijani' },
  { value: 'bak_Cyrl', label: 'Bashkir' },
  { value: 'bam_Latn', label: 'Bambara' },
  { value: 'ban_Latn', label: 'Balinese' },
  { value: 'bel_Cyrl', label: 'Belarusian' },
  { value: 'bem_Latn', label: 'Bemba' },
  { value: 'ben_Beng', label: 'Bengali' },
  { value: 'bho_Deva', label: 'Bhojpuri' },
  { value: 'bjn_Arab', label: 'Banjar (Arabic script)' },
  { value: 'bjn_Latn', label: 'Banjar (Latin script)' },
  { value: 'bod_Tibt', label: 'Standard Tibetan' },
  { value: 'bos_Latn', label: 'Bosnian' },
  { value: 'bug_Latn', label: 'Buginese' },
  { value: 'bul_Cyrl', label: 'Bulgarian' },
  { value: 'cat_Latn', label: 'Catalan' },
  { value: 'ceb_Latn', label: 'Cebuano' },
  { value: 'ces_Latn', label: 'Czech' },
  { value: 'cjk_Latn', label: 'Chokwe' },
  { value: 'ckb_Arab', label: 'Central Kurdish' },
  { value: 'crh_Latn', label: 'Crimean Tatar' },
  { value: 'cym_Latn', label: 'Welsh' },
  { value: 'dan_Latn', label: 'Danish' },
  { value: 'deu_Latn', label: 'German' },
  { value: 'dik_Latn', label: 'Southwestern Dinka' },
  { value: 'dyu_Latn', label: 'Dyula' },
  { value: 'dzo_Tibt', label: 'Dzongkha' },
  { value: 'ell_Grek', label: 'Greek' },
  { value: 'eng_Latn', label: 'English' },
  { value: 'epo_Latn', label: 'Esperanto' },
  { value: 'est_Latn', label: 'Estonian' },
  { value: 'eus_Latn', label: 'Basque' },
  { value: 'ewe_Latn', label: 'Ewe' },
  { value: 'fao_Latn', label: 'Faroese' },
  { value: 'fij_Latn', label: 'Fijian' },
  { value: 'fin_Latn', label: 'Finnish' },
  { value: 'fon_Latn', label: 'Fon' },
  { value: 'fra_Latn', label: 'French' },
  { value: 'fur_Latn', label: 'Friulian' },
  { value: 'fuv_Latn', label: 'Nigerian Fulfulde' },
  { value: 'gla_Latn', label: 'Scottish Gaelic' },
  { value: 'gle_Latn', label: 'Irish' },
  { value: 'glg_Latn', label: 'Galician' },
  { value: 'grn_Latn', label: 'Guarani' },
  { value: 'guj_Gujr', label: 'Gujarati' },
  { value: 'hat_Latn', label: 'Haitian Creole' },
  { value: 'hau_Latn', label: 'Hausa' },
  { value: 'heb_Hebr', label: 'Hebrew' },
  { value: 'hin_Deva', label: 'Hindi' },
  { value: 'hne_Deva', label: 'Chhattisgarhi' },
  { value: 'hrv_Latn', label: 'Croatian' },
  { value: 'hun_Latn', label: 'Hungarian' },
  { value: 'hye_Armn', label: 'Armenian' },
  { value: 'ibo_Latn', label: 'Igbo' },
  { value: 'ilo_Latn', label: 'Ilocano' },
  { value: 'ind_Latn', label: 'Indonesian' },
  { value: 'isl_Latn', label: 'Icelandic' },
  { value: 'ita_Latn', label: 'Italian' },
  { value: 'jav_Latn', label: 'Javanese' },
  { value: 'jpn_Jpan', label: 'Japanese' },
  { value: 'kab_Latn', label: 'Kabyle' },
  { value: 'kac_Latn', label: 'Jingpho' },
  { value: 'kam_Latn', label: 'Kamba' },
  { value: 'kan_Knda', label: 'Kannada' },
  { value: 'kas_Arab', label: 'Kashmiri (Arabic script)' },
  { value: 'kas_Deva', label: 'Kashmiri (Devanagari script)' },
  { value: 'kat_Geor', label: 'Georgian' },
  { value: 'knc_Arab', label: 'Central Kanuri (Arabic script)' },
  { value: 'knc_Latn', label: 'Central Kanuri (Latin script)' },
  { value: 'kaz_Cyrl', label: 'Kazakh' },
  { value: 'kbp_Latn', label: 'Kabiyè' },
  { value: 'kea_Latn', label: 'Kabuverdianu' },
  { value: 'khm_Khmr', label: 'Khmer' },
  { value: 'kik_Latn', label: 'Kikuyu' },
  { value: 'kin_Latn', label: 'Kinyarwanda' },
  { value: 'kir_Cyrl', label: 'Kyrgyz' },
  { value: 'kmb_Latn', label: 'Kimbundu' },
  { value: 'kmr_Latn', label: 'Northern Kurdish' },
  { value: 'kon_Latn', label: 'Kikongo' },
  { value: 'kor_Hang', label: 'Korean' },
  { value: 'lao_Laoo', label: 'Lao' },
  { value: 'lij_Latn', label: 'Ligurian' },
  { value: 'lim_Latn', label: 'Limburgish' },
  { value: 'lin_Latn', label: 'Lingala' },
  { value: 'lit_Latn', label: 'Lithuanian' },
  { value: 'lmo_Latn', label: 'Lombard' },
  { value: 'ltg_Latn', label: 'Latgalian' },
  { value: 'ltz_Latn', label: 'Luxembourgish' },
  { value: 'lua_Latn', label: 'Luba-Kasai' },
  { value: 'lug_Latn', label: 'Ganda' },
  { value: 'luo_Latn', label: 'Luo' },
  { value: 'lus_Latn', label: 'Mizo' },
  { value: 'lvs_Latn', label: 'Standard Latvian' },
  { value: 'mag_Deva', label: 'Magahi' },
  { value: 'mai_Deva', label: 'Maithili' },
  { value: 'mal_Mlym', label: 'Malayalam' },
  { value: 'mar_Deva', label: 'Marathi' },
  { value: 'min_Arab', label: 'Minangkabau (Arabic script)' },
  { value: 'min_Latn', label: 'Minangkabau (Latin script)' },
  { value: 'mkd_Cyrl', label: 'Macedonian' },
  { value: 'plt_Latn', label: 'Plateau Malagasy' },
  { value: 'mlt_Latn', label: 'Maltese' },
  { value: 'mni_Beng', label: 'Meitei (Bengali script)' },
  { value: 'khk_Cyrl', label: 'Halh Mongolian' },
  { value: 'mos_Latn', label: 'Mossi' },
  { value: 'mri_Latn', label: 'Maori' },
  { value: 'mya_Mymr', label: 'Burmese' },
  { value: 'nld_Latn', label: 'Dutch' },
  { value: 'nno_Latn', label: 'Norwegian Nynorsk' },
  { value: 'nob_Latn', label: 'Norwegian Bokmål' },
  { value: 'npi_Deva', label: 'Nepali' },
  { value: 'nso_Latn', label: 'Northern Sotho' },
  { value: 'nus_Latn', label: 'Nuer' },
  { value: 'nya_Latn', label: 'Nyanja' },
  { value: 'oci_Latn', label: 'Occitan' },
  { value: 'gaz_Latn', label: 'West Central Oromo' },
  { value: 'ory_Orya', label: 'Odia' },
  { value: 'pag_Latn', label: 'Pangasinan' },
  { value: 'pan_Guru', label: 'Eastern Panjabi' },
  { value: 'pap_Latn', label: 'Papiamento' },
  { value: 'pes_Arab', label: 'Western Persian' },
  { value: 'pol_Latn', label: 'Polish' },
  { value: 'por_Latn', label: 'Portuguese' },
  { value: 'prs_Arab', label: 'Dari' },
  { value: 'pbt_Arab', label: 'Southern Pashto' },
  { value: 'quy_Latn', label: 'Ayacucho Quechua' },
  { value: 'ron_Latn', label: 'Romanian' },
  { value: 'run_Latn', label: 'Rundi' },
  { value: 'rus_Cyrl', label: 'Russian' },
  { value: 'sag_Latn', label: 'Sango' },
  { value: 'san_Deva', label: 'Sanskrit' },
  { value: 'sat_Olck', label: 'Santali' },
  { value: 'scn_Latn', label: 'Sicilian' },
  { value: 'shn_Mymr', label: 'Shan' },
  { value: 'sin_Sinh', label: 'Sinhala' },
  { value: 'slk_Latn', label: 'Slovak' },
  { value: 'slv_Latn', label: 'Slovenian' },
  { value: 'smo_Latn', label: 'Samoan' },
  { value: 'sna_Latn', label: 'Shona' },
  { value: 'snd_Arab', label: 'Sindhi' },
  { value: 'som_Latn', label: 'Somali' },
  { value: 'sot_Latn', label: 'Southern Sotho' },
  { value: 'spa_Latn', label: 'Spanish' },
  { value: 'als_Latn', label: 'Tosk Albanian' },
  { value: 'srd_Latn', label: 'Sardinian' },
  { value: 'srp_Cyrl', label: 'Serbian' },
  { value: 'ssw_Latn', label: 'Swati' },
  { value: 'sun_Latn', label: 'Sundanese' },
  { value: 'swe_Latn', label: 'Swedish' },
  { value: 'swh_Latn', label: 'Swahili' },
  { value: 'szl_Latn', label: 'Silesian' },
  { value: 'tam_Taml', label: 'Tamil' },
  { value: 'tat_Cyrl', label: 'Tatar' },
  { value: 'tel_Telu', label: 'Telugu' },
  { value: 'tgk_Cyrl', label: 'Tajik' },
  { value: 'tgl_Latn', label: 'Tagalog' },
  { value: 'tha_Thai', label: 'Thai' },
  { value: 'tir_Ethi', label: 'Tigrinya' },
  { value: 'taq_Latn', label: 'Tamasheq (Latin script)' },
  { value: 'taq_Tfng', label: 'Tamasheq (Tifinagh script)' },
  { value: 'tpi_Latn', label: 'Tok Pisin' },
  { value: 'tsn_Latn', label: 'Tswana' },
  { value: 'tso_Latn', label: 'Tsonga' },
  { value: 'tuk_Latn', label: 'Turkmen' },
  { value: 'tum_Latn', label: 'Tumbuka' },
  { value: 'tur_Latn', label: 'Turkish' },
  { value: 'twi_Latn', label: 'Twi' },
  { value: 'tzm_Tfng', label: 'Central Atlas Tamazight' },
  { value: 'uig_Arab', label: 'Uyghur' },
  { value: 'ukr_Cyrl', label: 'Ukrainian' },
  { value: 'umb_Latn', label: 'Umbundu' },
  { value: 'urd_Arab', label: 'Urdu' },
  { value: 'uzn_Latn', label: 'Northern Uzbek' },
  { value: 'vec_Latn', label: 'Venetian' },
  { value: 'vie_Latn', label: 'Vietnamese' },
  { value: 'war_Latn', label: 'Waray' },
  { value: 'wol_Latn', label: 'Wolof' },
  { value: 'xho_Latn', label: 'Xhosa' },
  { value: 'ydd_Hebr', label: 'Eastern Yiddish' },
  { value: 'yor_Latn', label: 'Yoruba' },
  { value: 'yue_Hant', label: 'Yue Chinese' },
  { value: 'zho_Hans', label: 'Chinese (Simplified)' },
  { value: 'zho_Hant', label: 'Chinese (Traditional)' },
  { value: 'zsm_Latn', label: 'Standard Malay' },
  { value: 'zul_Latn', label: 'Zulu' },
];

export const Questionsinfo = {
  department_management: {
    questions: [
      "Retrieve all columns from the 'department' table.",
      'Retrieve the names of all departments.',
      'Count the number of departments.',
      'Retrieve the departments with a ranking greater than 5.',
      'Retrieve the budget of the department with ID 10.',
      'Retrieve the names of departments with budgets less than 1 billion.',
      'Retrieve the names of department heads.Retrieve the names and ages of department heads born in California.',
      'Retrieve the departments created after 2010.Count the number of departments each head manages.',
      'Retrieve the departments managed by head ID 20.',
    ],
  },
  customers_and_addresses: {
    questions: [
      'Find the name of all customers.',
      'What are the names of all the customers?',
      'How many customers are there?',
      'Return the total number of distinct customers.',
      'What is the average amount of items ordered in each order?',
      'Find the average order quantity per order.',
      'What are the names of customers who use payment method "Cash"?',
      'Which customers use "Cash" for payment method? Return the customer names.',
      'Find the "date became customers" of the customers whose ID is between 10 and 20.',
      'What are the dates when customers with ids between 10 and 20 became customers?',
      'Which payment method is used by most customers?',
    ],
  },
  store_1: {
    questions: [
      'A list of the top 5 countries by number of invoices. List country name and number of invoices.',
      'What are the top 5 countries by number of invoices and how many do they have?',
      'A list of the top 8 countries by gross/total invoice size. List country name and gross invoice size.',
      'What are the names of the top 8 countries by total invoice size and what are those sizes?',
      'A list of the top 10 countries by average invoice size. List country name and average invoice size.',
      'What are the names of the countries and average invoice size of the top countries by size?',
      "Find out 5 customers who most recently purchased something. List customers' first and last name.",
      'What are the first and last names of the 5 customers who purchased something most recently?',
      "Find out the top 10 customers by total number of orders. List customers' first and last name and the number of total orders.",
      "What are the top 10 customers' first and last names by total number of orders and how many orders did they make?",
      "List the top 10 customers by total gross sales. List customers' first and last name and total gross sales.",
    ],
  },
};

export const SchemaInfo = {
  department_management:
    'CREATE TABLE IF NOT EXISTS "department" (\n"Department_ID" int,\n"Name" text,\n"Creation" text,\n"Ranking" int,\n"Budget_in_Billions" real,\n"Num_Employees" real,\nPRIMARY KEY ("Department_ID")\n);\nCREATE TABLE IF NOT EXISTS "head" (\n"head_ID" int,\n"name" text,\n"born_state" text,\n"age" real,\nPRIMARY KEY ("head_ID")\n);\nCREATE TABLE IF NOT EXISTS "management" (\n"department_ID" int,\n"head_ID" int,\n"temporary_acting" text,\nPRIMARY KEY ("Department_ID","head_ID"),\nFOREIGN KEY ("Department_ID") REFERENCES "department"("Department_ID"),\nFOREIGN KEY ("head_ID") REFERENCES "head"("head_ID")\n);\n',
  customers_and_addresses:
    'CREATE TABLE "Addresses" (\n"address_id" INTEGER PRIMARY KEY,\n"address_content" VARCHAR(80),\n"city" VARCHAR(50),\n"zip_postcode" VARCHAR(20),\n"state_province_county" VARCHAR(50),\n"country" VARCHAR(50),\n"other_address_details" VARCHAR(255)\n);\nCREATE TABLE "Products" (\n"product_id" INTEGER PRIMARY KEY,\n"product_details" VARCHAR(255)\n);\nCREATE TABLE "Customers" (\n"customer_id" INTEGER PRIMARY KEY,\n"payment_method" VARCHAR(15) NOT NULL,\n"customer_name" VARCHAR(80),\n"date_became_customer" DATETIME,\n"other_customer_details" VARCHAR(255)\n);\nCREATE TABLE "Customer_Addresses" (\n"customer_id" INTEGER NOT NULL,\n"address_id" INTEGER NOT NULL,\n"date_address_from" DATETIME NOT NULL,\n"address_type" VARCHAR(15) NOT NULL,\n"date_address_to" DATETIME,\nFOREIGN KEY ("address_id" ) REFERENCES "Addresses"("address_id" ),\nFOREIGN KEY ("customer_id" ) REFERENCES "Customers"("customer_id" )\n);\nCREATE TABLE "Customer_Contact_Channels" (\n"customer_id" INTEGER NOT NULL,\n"channel_code" VARCHAR(15) NOT NULL,\n"active_from_date" DATETIME NOT NULL,\n"active_to_date" DATETIME,\n"contact_number" VARCHAR(50) NOT NULL,\nFOREIGN KEY ("customer_id" ) REFERENCES "Customers"("customer_id" )\n);\nCREATE TABLE "Customer_Orders" (\n"order_id" INTEGER PRIMARY KEY,\n"customer_id" INTEGER NOT NULL,\n"order_status" VARCHAR(15) NOT NULL,\n"order_date" DATETIME,\n"order_details" VARCHAR(255),\nFOREIGN KEY ("customer_id" ) REFERENCES "Customers"("customer_id" )\n);\nCREATE TABLE "Order_Items" (\n"order_id" INTEGER NOT NULL,\n"product_id" INTEGER NOT NULL,\n"order_quantity" VARCHAR(15),\nFOREIGN KEY ("product_id" ) REFERENCES "Products"("product_id" ),\nFOREIGN KEY ("order_id" ) REFERENCES "Customer_Orders"("order_id" )\n);\n',
  driving_school:
    'CREATE TABLE "Addresses" (\n"address_id" INTEGER PRIMARY KEY,\n"line_1_number_building" VARCHAR(80),\n"city" VARCHAR(50),\n"zip_postcode" VARCHAR(20),\n"state_province_county" VARCHAR(50),\n"country" VARCHAR(50)\n);\nCREATE TABLE "Staff" (\n"staff_id" INTEGER PRIMARY KEY,\n"staff_address_id" INTEGER NOT NULL,\n"nickname" VARCHAR(80),\n"first_name" VARCHAR(80),\n"middle_name" VARCHAR(80),\n"last_name" VARCHAR(80),\n"date_of_birth" DATETIME,\n"date_joined_staff" DATETIME,\n"date_left_staff" DATETIME,\nFOREIGN KEY ("staff_address_id" ) REFERENCES "Addresses"("address_id" )\n);\nCREATE TABLE "Vehicles" (\n"vehicle_id" INTEGER PRIMARY KEY,\n"vehicle_details" VARCHAR(255)\n);\nCREATE TABLE "Customers" (\n"customer_id" INTEGER PRIMARY KEY,\n"customer_address_id" INTEGER NOT NULL,\n"customer_status_code" VARCHAR(15) NOT NULL,\n"date_became_customer" DATETIME,\n"date_of_birth" DATETIME,\n"first_name" VARCHAR(80),\n"last_name" VARCHAR(80),\n"amount_outstanding" DOUBLE NULL,\n"email_address" VARCHAR(250),\n"phone_number" VARCHAR(255),\n"cell_mobile_phone_number" VARCHAR(255),\nFOREIGN KEY ("customer_address_id" ) REFERENCES "Addresses"("address_id" )\n);\nCREATE TABLE "Customer_Payments" (\n"customer_id" INTEGER NOT NULL,\n"datetime_payment" DATETIME NOT NULL,\n"payment_method_code" VARCHAR(10) NOT NULL,\n"amount_payment" DOUBLE NULL,\nPRIMARY KEY ("customer_id","datetime_payment"),\nFOREIGN KEY ("customer_id" ) REFERENCES "Customers"("customer_id" )\n);\nCREATE TABLE "Lessons" (\n"lesson_id" INTEGER PRIMARY KEY,\n"customer_id" INTEGER NOT NULL,\n"lesson_status_code" VARCHAR(15) NOT NULL,\n"staff_id" INTEGER,\n"vehicle_id" INTEGER NOT NULL,\n"lesson_date" DATETIME,\n"lesson_time" VARCHAR(10),\n"price" DOUBLE NULL,\nFOREIGN KEY ("vehicle_id" ) REFERENCES "Vehicles"("vehicle_id" ),\nFOREIGN KEY ("staff_id" ) REFERENCES "Staff"("staff_id" ),\nFOREIGN KEY ("customer_id" ) REFERENCES "Customers"("customer_id" )\n);\n',
  gymnast:
    'CREATE TABLE "gymnast" (\n"Gymnast_ID" int,\n"Floor_Exercise_Points" real,\n"Pommel_Horse_Points" real,\n"Rings_Points" real,\n"Vault_Points" real,\n"Parallel_Bars_Points" real,\n"Horizontal_Bar_Points" real,\n"Total_Points" real,\nPRIMARY KEY ("Gymnast_ID"),\nFOREIGN KEY ("Gymnast_ID") REFERENCES "people"("People_ID")\n);\nCREATE TABLE "people" (\n"People_ID" int,\n"Name" text,\n"Age" real,\n"Height" real,\n"Hometown" text,\nPRIMARY KEY ("People_ID")\n);\n',
  university_basketball:
    'CREATE TABLE "basketball_match" (\n"Team_ID" int,\n"School_ID" int,\n"Team_Name" text,\n"ACC_Regular_Season" text,\n"ACC_Percent" text,\n"ACC_Home" text,\n"ACC_Road" text,\n"All_Games" text,\n"All_Games_Percent" int,\n"All_Home" text,\n"All_Road" text,\n"All_Neutral" text,\nPRIMARY KEY ("Team_ID"),\nFOREIGN KEY ("School_ID") REFERENCES "university"("School_ID")\n);\nCREATE TABLE "university" (\n"School_ID" int,\n"School" text,\n"Location" text,\n"Founded" real,\n"Affiliation" text,\n"Enrollment" real,\n"Nickname" text,\n"Primary_conference" text,\nPRIMARY KEY ("School_ID")\n);\n',
  flight_company:
    'CREATE TABLE "airport" (\n"id" int,\n"City" text,\n"Country" text,\n"IATA" text,\n"ICAO" text,\n"name" text,\nprimary key("id")\n);\nCREATE TABLE "operate_company" (\n"id" int,\n"name" text,\n"Type" text,\n"Principal_activities" text,\n"Incorporated_in" text,\n"Group_Equity_Shareholding" real,\nprimary key ("id")\n);\nCREATE TABLE "flight" (\n"id" int,\n"Vehicle_Flight_number" text,\n"Date" text,\n"Pilot" text,\n"Velocity" real,\n"Altitude" real,\n"airport_id" int,\n"company_id" int,\nprimary key ("id"),\nforeign key ("airport_id") references "airport"("id"),\nforeign key ("company_id") references "operate_company"("id")\n);\n',
  assets_maintenance:
    'CREATE TABLE "Third_Party_Companies" (\n"company_id" INTEGER PRIMARY KEY ,\n"company_type" VARCHAR(5) NOT NULL,\n"company_name" VARCHAR(255),\n"company_address" VARCHAR(255),\n"other_company_details" VARCHAR(255)\n);\nCREATE TABLE "Maintenance_Contracts" (\n"maintenance_contract_id" INTEGER PRIMARY KEY,\n"maintenance_contract_company_id" INTEGER NOT NULL,\n"contract_start_date" DATETIME,\n"contract_end_date" DATETIME,\n"other_contract_details" VARCHAR(255),\nFOREIGN KEY ("maintenance_contract_company_id" ) REFERENCES "Third_Party_Companies"("company_id" )\n);\nCREATE TABLE "Parts" (\n"part_id" INTEGER PRIMARY KEY,\n"part_name" VARCHAR(255),\n"chargeable_yn" VARCHAR(1),\n"chargeable_amount" VARCHAR(20),\n"other_part_details" VARCHAR(255)\n);\nCREATE TABLE "Skills" (\n"skill_id" INTEGER PRIMARY KEY,\n"skill_code" VARCHAR(20),\n"skill_description" VARCHAR(255)\n);\nCREATE TABLE "Staff" (\n"staff_id" INTEGER PRIMARY KEY,\n"staff_name" VARCHAR(255),\n"gender" VARCHAR(1),\n"other_staff_details" VARCHAR(255)\n);\nCREATE TABLE "Assets" (\n"asset_id" INTEGER PRIMARY KEY,\n"maintenance_contract_id" INTEGER NOT NULL,\n"supplier_company_id" INTEGER NOT NULL,\n"asset_details" VARCHAR(255),\n"asset_make" VARCHAR(20),\n"asset_model" VARCHAR(20),\n"asset_acquired_date" DATETIME,\n"asset_disposed_date" DATETIME,\n"other_asset_details" VARCHAR(255),\nFOREIGN KEY ("maintenance_contract_id" )\nREFERENCES "Maintenance_Contracts"("maintenance_contract_id" ),\nFOREIGN KEY ("supplier_company_id" ) REFERENCES "Third_Party_Companies"("company_id" )\n);\nCREATE TABLE "Asset_Parts" (\n"asset_id" INTEGER NOT NULL,\n"part_id" INTEGER NOT NULL,\nFOREIGN KEY ("part_id" ) REFERENCES "Parts"("part_id" ),\nFOREIGN KEY ("asset_id" ) REFERENCES "Assets"("asset_id" )\n);\nCREATE TABLE "Maintenance_Engineers" (\n"engineer_id" INTEGER PRIMARY KEY,\n"company_id" INTEGER NOT NULL,\n"first_name" VARCHAR(50),\n"last_name" VARCHAR(50),\n"other_details" VARCHAR(255),\nFOREIGN KEY ("company_id" ) REFERENCES "Third_Party_Companies"("company_id" )\n);\nCREATE TABLE "Engineer_Skills" (\n"engineer_id" INTEGER NOT NULL,\n"skill_id" INTEGER NOT NULL,\nFOREIGN KEY ("engineer_id" ) REFERENCES "Maintenance_Engineers"("engineer_id" ),\nFOREIGN KEY ("skill_id" ) REFERENCES "Skills"("skill_id" )\n);\nCREATE TABLE "Fault_Log" (\n"fault_log_entry_id" INTEGER PRIMARY KEY,\n"asset_id" INTEGER NOT NULL,\n"recorded_by_staff_id" INTEGER NOT NULL,\n"fault_log_entry_datetime" DATETIME,\n"fault_description" VARCHAR(255),\n"other_fault_details" VARCHAR(255),\nFOREIGN KEY ("asset_id" ) REFERENCES "Assets"("asset_id" ),\nFOREIGN KEY ("recorded_by_staff_id" ) REFERENCES "Staff"("staff_id" )\n);\nCREATE TABLE "Engineer_Visits" (\n"engineer_visit_id" INTEGER PRIMARY KEY,\n"contact_staff_id" INTEGER,\n"engineer_id" INTEGER NOT NULL,\n"fault_log_entry_id" INTEGER NOT NULL,\n"fault_status" VARCHAR(10) NOT NULL,\n"visit_start_datetime" DATETIME,\n"visit_end_datetime" DATETIME,\n"other_visit_details" VARCHAR(255),\nFOREIGN KEY ("fault_log_entry_id" ) REFERENCES "Fault_Log"("fault_log_entry_id" ),\nFOREIGN KEY ("engineer_id" ) REFERENCES "Maintenance_Engineers"("engineer_id" ),\nFOREIGN KEY ("contact_staff_id" ) REFERENCES "Staff"("staff_id" )\n);\nCREATE TABLE "Part_Faults" (\n"part_fault_id" INTEGER PRIMARY KEY,\n"part_id" INTEGER NOT NULL,\n"fault_short_name" VARCHAR(20),\n"fault_description" VARCHAR(255),\n"other_fault_details" VARCHAR(255),\nFOREIGN KEY ("part_id" ) REFERENCES "Parts"("part_id" )\n);\nCREATE TABLE "Fault_Log_Parts" (\n"fault_log_entry_id" INTEGER NOT NULL,\n"part_fault_id" INTEGER NOT NULL,\n"fault_status" VARCHAR(10) NOT NULL,\nFOREIGN KEY ("part_fault_id" ) REFERENCES "Part_Faults"("part_fault_id" ),\nFOREIGN KEY ("fault_log_entry_id" ) REFERENCES "Fault_Log"("fault_log_entry_id" )\n);\nCREATE TABLE "Skills_Required_To_Fix" (\n"part_fault_id" INTEGER NOT NULL,\n"skill_id" INTEGER NOT NULL,\nFOREIGN KEY ("part_fault_id" ) REFERENCES "Part_Faults"("part_fault_id" ),\nFOREIGN KEY ("skill_id" ) REFERENCES "Skills"("skill_id" )\n);\n',
  candidate_poll:
    'CREATE TABLE "candidate" (\n"Candidate_ID" int,\n"People_ID" int,\n"Poll_Source" text,\n"Date" text,\n"Support_rate" real,\n"Consider_rate" real,\n"Oppose_rate" real,\n"Unsure_rate" real,\nPRIMARY KEY ("Candidate_ID"),\nFOREIGN KEY ("People_ID") REFERENCES "people"("People_ID")\n);\nCREATE TABLE "people" (\n"People_ID" int,\n"Sex" text,\n"Name" text,\n"Date_of_Birth" text,\n"Height" real,\n"Weight" real,\nPRIMARY KEY ("People_ID")\n);\n',
  journal_committee:
    'CREATE TABLE IF NOT EXISTS "journal" (\n"Journal_ID" int,\n"Date" text,\n"Theme" text,\n"Sales" int,\nPRIMARY KEY ("Journal_ID")\n);\nCREATE TABLE IF NOT EXISTS "editor" (\n"Editor_ID" int,\n"Name" text,\n"Age" real,\nPRIMARY KEY ("Editor_ID")\n);\nCREATE TABLE IF NOT EXISTS "journal_committee" (\n"Editor_ID" int,\n"Journal_ID" int,\n"Work_Type" text,\nPRIMARY KEY ("Editor_ID","Journal_ID"),\nFOREIGN KEY ("Editor_ID") REFERENCES "editor"("Editor_ID"),\nFOREIGN KEY ("Journal_ID") REFERENCES "journal"("Journal_ID")\n);\n',
  swimming:
    'CREATE TABLE "swimmer" (\n"ID" int,\n"name" text,\n"Nationality" text,\n"meter_100" real,\n"meter_200" text,\n"meter_300" text,\n"meter_400" text,\n"meter_500" text,\n"meter_600" text,\n"meter_700" text,\n"Time" text,\nPRIMARY KEY ("ID")\n);\nCREATE TABLE "stadium" (\n"ID" int,\n"name" text,\n"Capacity" int,\n"City" text,\n"Country" text,\n"Opening_year" int,\nPRIMARY KEY ("ID")\n);\nCREATE TABLE "event" (\n"ID" int,\n"Name" text,\n"Stadium_ID" int,\n"Year" text,\nPRIMARY KEY ("ID"),\nFOREIGN KEY ("Stadium_ID") REFERENCES "stadium"("ID")\n);\nCREATE TABLE "record" (\n"ID" int,\n"Result" text,\n"Swimmer_ID" int,\n"Event_ID" int,\nPRIMARY KEY ("Swimmer_ID","Event_ID"),\nFOREIGN KEY ("Event_ID") REFERENCES "event"("ID"),\nFOREIGN KEY ("Swimmer_ID") REFERENCES "swimmer"("ID")\n);\n',
  store_1:
    'CREATE TABLE artists\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nname VARCHAR(120)\n);\nCREATE TABLE albums\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\ntitle VARCHAR(160)  NOT NULL,\nartist_id INTEGER  NOT NULL,\nFOREIGN KEY (artist_id) REFERENCES artists (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE employees\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nlast_name VARCHAR(20)  NOT NULL,\nfirst_name VARCHAR(20)  NOT NULL,\ntitle VARCHAR(30),\nreports_to INTEGER,\nbirth_date TIMESTAMP,\nhire_date TIMESTAMP,\naddress VARCHAR(70),\ncity VARCHAR(40),\nstate VARCHAR(40),\ncountry VARCHAR(40),\npostal_code VARCHAR(10),\nphone VARCHAR(24),\nfax VARCHAR(24),\nemail VARCHAR(60),\nFOREIGN KEY (reports_to) REFERENCES employees (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE customers\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nfirst_name VARCHAR(40)  NOT NULL,\nlast_name VARCHAR(20)  NOT NULL,\ncompany VARCHAR(80),\naddress VARCHAR(70),\ncity VARCHAR(40),\nstate VARCHAR(40),\ncountry VARCHAR(40),\npostal_code VARCHAR(10),\nphone VARCHAR(24),\nfax VARCHAR(24),\nemail VARCHAR(60)  NOT NULL,\nsupport_rep_id INTEGER,\nFOREIGN KEY (support_rep_id) REFERENCES employees (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE genres\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nname VARCHAR(120)\n);\nCREATE TABLE invoices\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\ncustomer_id INTEGER  NOT NULL,\ninvoice_date TIMESTAMP  NOT NULL,\nbilling_address VARCHAR(70),\nbilling_city VARCHAR(40),\nbilling_state VARCHAR(40),\nbilling_country VARCHAR(40),\nbilling_postal_code VARCHAR(10),\ntotal NUMERIC(10,2)  NOT NULL,\nFOREIGN KEY (customer_id) REFERENCES customers (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE media_types\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nname VARCHAR(120)\n);\nCREATE TABLE tracks\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nname VARCHAR(200)  NOT NULL,\nalbum_id INTEGER,\nmedia_type_id INTEGER  NOT NULL,\ngenre_id INTEGER,\ncomposer VARCHAR(220),\nmilliseconds INTEGER  NOT NULL,\nbytes INTEGER,\nunit_price NUMERIC(10,2)  NOT NULL,\nFOREIGN KEY (album_id) REFERENCES albums (id)\nON DELETE NO ACTION ON UPDATE NO ACTION,\nFOREIGN KEY (genre_id) REFERENCES genres (id)\nON DELETE NO ACTION ON UPDATE NO ACTION,\nFOREIGN KEY (media_type_id) REFERENCES media_types (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE invoice_lines\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\ninvoice_id INTEGER  NOT NULL,\ntrack_id INTEGER  NOT NULL,\nunit_price NUMERIC(10,2)  NOT NULL,\nquantity INTEGER  NOT NULL,\nFOREIGN KEY (invoice_id) REFERENCES invoices (id)\nON DELETE NO ACTION ON UPDATE NO ACTION,\nFOREIGN KEY (track_id) REFERENCES tracks (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\nCREATE TABLE playlists\n(\nid INTEGER PRIMARY KEY AUTOINCREMENT,\nname VARCHAR(120)\n);\nCREATE TABLE playlist_tracks\n(\nplaylist_id INTEGER  NOT NULL,\ntrack_id INTEGER  NOT NULL,\nCONSTRAINT PK_PlaylistTrack PRIMARY KEY  (playlist_id, track_id),\nFOREIGN KEY (playlist_id) REFERENCES playlists (id)\nON DELETE NO ACTION ON UPDATE NO ACTION,\nFOREIGN KEY (track_id) REFERENCES tracks (id)\nON DELETE NO ACTION ON UPDATE NO ACTION\n);\n',
};
